var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrainingsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-trainings{fill:#c5c9f6;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-book-reader-2",
    "data-name": "Icon awesome-book-reader-2",
    className: "cls-trainings",
    d: "M14.79,4.74A3.81,3.81,0,1,0,11,8.55a3.82,3.82,0,0,0,3.81-3.81Zm-4.7,5.76C7.74,9.06,3.92,8.66,2,8.55a1.1,1.1,0,0,0-1.18,1v8.91a1.09,1.09,0,0,0,1.05,1.07,21.46,21.46,0,0,1,7.66,1.64.56.56,0,0,0,.75-.22.54.54,0,0,0,.06-.25V11a.48.48,0,0,0-.25-.45ZM20,8.55c-1.91.11-5.73.51-8.08,1.95a.53.53,0,0,0-.26.46v9.75a.56.56,0,0,0,.57.54.72.72,0,0,0,.25-.07,21.42,21.42,0,0,1,7.66-1.64,1.1,1.1,0,0,0,1.05-1.08V9.63A1.11,1.11,0,0,0,20,8.55Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingsIcon);
export default __webpack_public_path__ + "static/media/trainings-icon.fee05f8501a4c41476077fadb024faf7.svg";
export { ForwardRef as ReactComponent };